export default function GetRole({ roles, roleId }) {
  const searchRole = roles.find((role) => role.id == roleId);
  return searchRole ? searchRole.title : "תפקיד לא מוגדר";
}
